import { PriceBreakdownItem } from '@/components/listing/price-breakdown-popover';

export const DISCOUNT_LABEL_CLASS =
  'font-bold !text-success-main hover:!text-success-dark';
export const DISCOUNT_AMOUNT_CLASS = 'font-bold text-success-main';

export const toDiscountPriceItems = (
  lines: { label: string; amount: number }[]
): PriceBreakdownItem[] =>
  lines.map((line) => ({
    label: line.label,
    price: -line.amount,
    labelClassName: DISCOUNT_LABEL_CLASS,
    priceClassName: DISCOUNT_AMOUNT_CLASS,
    useAccountingFormat: false,
  }));
